import { useEffect, useState } from 'react'
import { Typography, CircularProgress } from '@mui/material'
import moment from 'moment'
import { LineGraph } from '@components/v2/line-graph'
import { api } from 'api'
import { t } from '@lingui/core/macro'

export const SubmissionHistory = () => {
  const [chartData, setChartdata] = useState([])

  useEffect(() => {
    api.get('/api/v1/account/reports/charts').then(res => {
      const months = moment.monthsShort()

      const data = res.data.charts

      let cd = []
      const currentMonth = new Date().getMonth() + 1

      const startMonth = currentMonth + (7 % 12)
      const validMonths = {}
      const order = []

      for (let i = 0; i < 6; i++) {
        if (startMonth + i > 12) {
          validMonths[startMonth + i - 12] = 0
          order.push(startMonth + i - 12)
        } else {
          validMonths[startMonth + i] = 0
          order.push(startMonth + i)
        }
      }

      data.forEach(month => {
        validMonths[month.month] = month.codes_submitted
      })

      cd = order.map(month => ({ x: months[month - 1], y: validMonths[month] }))

      setChartdata(cd)
    })
  }, [])

  return (
    <div style={{ minHeight: 300 }}>
      <div style={{ paddingTop: 12 }}>
        <div
          style={{
            height: '60px',
            width: '140px',
            textAlign: 'center',
          }}
        >
          <Typography variant="h6" style={{ paddingTop: '15px', paddingLeft: '28px' }}>
            {t`Submitted rows`}
          </Typography>
        </div>
      </div>
      {chartData.length ? (
        <LineGraph data={[{ id: 'submissions', data: chartData }]} />
      ) : (
        <div style={{ width: '100%', height: 100, textAlign: 'center' }}>
          <CircularProgress color="secondary" />
        </div>
      )}
    </div>
  )
}
